export class Category {
  id: number = 0;
  name: string = "";
  subCategories: Category[] = [];
  parentCategory: Category|undefined
  constructor() {
    this.id = 0;
    this.name = "";
  }
  parseJson(retCat: { id: number; attributes: { [key: string]: any } }) {
    this.id = retCat.id;
    this.name = retCat.attributes.Name;
    this.subCategories = [];
    if(retCat.attributes.parent && retCat.attributes.parent.data){
      const parentCategory = new Category()
      parentCategory.parseJson(retCat.attributes.parent.data)
      this.parentCategory = parentCategory
    }
    if (retCat.attributes.categories) {
      if (retCat.attributes.categories.data) {
        retCat.attributes.categories.data.forEach((value) => {
          const tempCat = new Category();
          tempCat.parseJson(value);
          this.subCategories.push(tempCat);
        });
      }
    }
  }
}
